var _rect, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSilver(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 26,
    viewBox: "0 0 54 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 53,
    height: 26,
    rx: 13,
    fill: "url(#paint0_linear_1569_48371)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.424 17.132C16.452 17.132 17.7 15.92 17.7 14.396C17.7 12.62 16.632 12.056 14.556 11.792C13.236 11.6 12.96 11.312 12.96 10.7C12.96 10.124 13.392 9.728 14.244 9.728C15.096 9.728 15.552 10.088 15.672 10.868H17.46C17.304 9.164 16.176 8.3 14.244 8.3C12.348 8.3 11.124 9.392 11.124 10.856C11.124 12.512 12.024 13.172 14.22 13.46C15.48 13.652 15.84 13.892 15.84 14.576C15.84 15.248 15.276 15.716 14.424 15.716C13.152 15.716 12.828 15.08 12.744 14.312H10.884C10.992 16.028 12.072 17.132 14.424 17.132ZM18.9918 17H20.7198V10.724H18.9918V17ZM19.8438 9.872C20.4078 9.872 20.8398 9.464 20.8398 8.924C20.8398 8.384 20.4078 7.976 19.8438 7.976C19.2918 7.976 18.8598 8.384 18.8598 8.924C18.8598 9.464 19.2918 9.872 19.8438 9.872ZM22.3668 17H24.0948V7.88H22.3668V17ZM27.3741 17H29.3301L31.6101 10.724H29.9301L28.4421 15.212L26.9421 10.724H25.0821L27.3741 17ZM35.1366 17.132C36.8526 17.132 37.9326 16.376 38.1366 15.02H36.4926C36.3846 15.548 35.9886 15.896 35.1846 15.896C34.2366 15.896 33.6726 15.296 33.6246 14.252H38.1486V13.772C38.1486 11.528 36.7086 10.58 35.0886 10.58C33.2646 10.58 31.8606 11.864 31.8606 13.844V13.94C31.8606 15.944 33.2406 17.132 35.1366 17.132ZM33.6486 13.184C33.7806 12.296 34.3086 11.78 35.0886 11.78C35.9166 11.78 36.3966 12.236 36.4566 13.184H33.6486ZM39.2875 17H41.0275V13.856C41.0275 12.656 41.7715 12.236 43.0555 12.248V10.628C42.0355 10.64 41.4235 11.084 41.0275 11.924V10.724H39.2875V17Z",
    fill: "#0B0B0C"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1569_48371",
    x1: 0.5,
    y1: 0,
    x2: 55.1724,
    y2: 22.473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEAEAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.400005,
    stopColor: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76629,
    stopColor: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9E9E9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSilver);
export default __webpack_public_path__ + "static/media/silver.55c5ad6d6f7946b5d21a7824c89904f7.svg";
export { ForwardRef as ReactComponent };